module.exports = __webpack_public_path__ + "static/media/Path 1661.72194a3f.svg";